"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var module_components_1 = require("@empiriecom/module-components");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var newsletterSheetTexts = react_intl_1.defineMessages({
    pendingLayerHeadline: {
        id: 'nlSheet.pendingLayerHeadline',
        defaultMessage: '{content}',
    },
    pendingLayerContent: {
        id: 'nlSheet.pendingLayerContent',
        defaultMessage: '{content}',
    },
});
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1.938rem;\n\n  div:first-child {\n    margin-bottom: 1rem;\n  }\n"], ["\n  margin-bottom: 1.938rem;\n\n  div:first-child {\n    margin-bottom: 1rem;\n  }\n"])));
var Page2 = function () {
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement(StyledContainer, { "data-testid": "pendingLayerHeadline" },
        react_1.default.createElement(module_components_1.Headline, { level: 4, element: "div" }, intl.formatMessage(newsletterSheetTexts.pendingLayerHeadline)),
        react_1.default.createElement("div", { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: intl.formatMessage(newsletterSheetTexts.pendingLayerContent),
            } })));
};
exports.default = Page2;
var templateObject_1;
//# sourceMappingURL=Page2.js.map